import { CalendarClock, Compass } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import CostOptimizer from "./CostExplorer";
import CostExplorerMockup from "./CostExplorerMockup";
import "./CostExplorerMockup.less";

type CostView = "explorer" | "optimizer";

export default function CostManagement() {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeView: CostView = searchParams.get("view") === "optimizer" ? "optimizer" : "explorer";

    const changeView = (view: string) => {
        const next = new URLSearchParams(searchParams);
        if (view === "optimizer") {
            next.set("view", "optimizer");
        } else {
            next.delete("view");
        }
        setSearchParams(next, { replace: true });
    };

    const navigation = (
        <TabsList className="cost-section-tabs">
            <TabsTrigger value="explorer">
                <Compass size={16} />
                Explorer
            </TabsTrigger>
            <TabsTrigger value="optimizer">
                <CalendarClock size={16} />
                Schedules
            </TabsTrigger>
        </TabsList>
    );

    return (
        <Tabs className="cost-management" value={activeView} onValueChange={changeView}>
            <TabsContent value="explorer">
                <CostExplorerMockup navigation={navigation} onOpenOptimizer={() => changeView("optimizer")} />
            </TabsContent>
            <TabsContent value="optimizer">
                <CostOptimizer navigation={navigation} />
            </TabsContent>
        </Tabs>
    );
}
